<button *ngIf="!board.sprintStartDate && (isNotGuest$ | async)" (click)="onClick()"><span class="play"></span>Start Sprint</button>
<sprint-percent-indicator *ngIf="board.sprintStartDate" [boardId]="board.id"></sprint-percent-indicator>
